"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return RedisCacheMgr;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _ioredis = /*#__PURE__*/ _interop_require_default(require("ioredis"));
const _CacheMgr = /*#__PURE__*/ _interop_require_default(require("./CacheMgr"));
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const _log = (0, _debug.default)('nc:cache');
let RedisCacheMgr = class RedisCacheMgr extends _CacheMgr.default {
    constructor(config){
        super();
        this.client = new _ioredis.default(config);
        // avoid flushing db in worker container
        if (process.env.NC_WORKER_CONTAINER !== 'true' && (process.env.NC_FLUSH_CACHE === 'true' || process.env.NC_CLOUD !== 'true') && process.env.NC_KEEP_CACHE !== 'true') {
            // flush the existing db with selected key (Default: 0)
            this.client.flushdb();
        }
        // TODO(cache): fetch orgs once it's implemented
        const orgs = 'noco';
        this.prefix = `${_globals.CACHE_PREFIX}:${orgs}`;
        this.context = 'RedisCacheMgr';
    }
};
